/**
* 创建于 2018/7/25
* 作者: SHERlocked93
* 功能: 加载动画 Loading Animation
*/


<template>
  <div class='loading' id='loading-animation'>
    <h2 id='artical-content'>Loading Animation</h2>
    
    除了下面的组件方式实现之外还可以使用GIF直接代替，缺点当然显而易见，灵活性不够；这里推介一个自助<a href='http://ajaxload.info/'>生成GIF的小网站</a>；
    
    <!--#01 音阶波浪 Loading效果-->
    <h3>音阶波浪 Loading效果</h3>
    <demo-block>
      <template slot='blackboard'>
        <demo-box thisName='LoadingAnimation0101'>
          <loading-animation0101 timingFunction='ease'></loading-animation0101>
        </demo-box>
        <demo-box thisName='LoadingAnimation0101'>
          <loading-animation0101 timingFunction='ease-in'></loading-animation0101>
        </demo-box>
        <demo-box thisName='LoadingAnimation0101'>
          <loading-animation0101 timingFunction='linear'></loading-animation0101>
        </demo-box>
        <demo-box thisName='LoadingAnimation0102'>
          <loading-animation0102></loading-animation0102>
        </demo-box>
      </template>
      
      <template slot='description'>
        根据自己需要修改<code>timingFunction</code>的动效，参数为<code>animation-timing-function</code>。
      </template>
      
      <template slot='realization'>
        <p data-height="265" data-theme-id="light" data-slug-hash="YjQQoR" data-default-tab="css,result" data-user="SHERlocked93" data-pen-title="CSS3 Loading Animation" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/SHERlocked93/pen/YjQQoR/">CSS3 Loading Animation</a> by SHERlocked93 (<a href="https://codepen.io/SHERlocked93">@SHERlocked93</a>) on
          <a href="https://codepen.io">CodePen</a>.</p>
        
        <p data-height="265" data-theme-id="light" data-slug-hash="yJxFo" data-default-tab="css,result" data-user="filipekiss" data-pen-title="Loading Animations" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/filipekiss/pen/yJxFo/">Loading Animations</a> by Filipe Kiss (<a href="https://codepen.io/filipekiss">@filipekiss</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
      </template>
    </demo-block>
    
    <!--#02 小球球 Loading效果-->
    <h3>小球球 Loading效果</h3>
    <demo-block>
      <template slot='blackboard'>
        <demo-box thisName='LoadingAnimation0201'>
          <loading-animation0201></loading-animation0201>
        </demo-box>
        <demo-box thisName='LoadingAnimation0203'>
          <loading-animation0203></loading-animation0203>
        </demo-box>
        <demo-box thisName='LoadingAnimation0204'>
          <loading-animation0204></loading-animation0204>
        </demo-box>
        <demo-box thisName='LoadingAnimation0202'>
          <loading-animation0202></loading-animation0202>
        </demo-box>
      </template>
      
      <template slot='realization'>
        <p data-height="265" data-theme-id="light" data-slug-hash="zrijB" data-default-tab="css,result" data-user="stryju" data-pen-title="@desnadro's [Loader dots], but one element"
           data-preview="true" class="codepen">See the Pen <a href="https://codepen.io/stryju/pen/zrijB/">@desnadro's [Loader dots], but one element</a> by tomasz stryjewski (<a
          href="https://codepen.io/stryju">@stryju</a>) on <a href="https://codepen.io">CodePen</a>.</p>
        
        <p data-height="265" data-theme-id="light" data-slug-hash="DusIE" data-default-tab="css,result" data-user="janrubio" data-pen-title="Windows 8 Loading Animation" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/janrubio/pen/DusIE/">Windows 8 Loading Animation</a> by Jan Rubio (<a href="https://codepen.io/janrubio">@janrubio</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
        
        <p data-height="265" data-theme-id="light" data-slug-hash="yJxFo" data-default-tab="css,result" data-user="filipekiss" data-pen-title="Loading Animations" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/filipekiss/pen/yJxFo/">Loading Animations</a> by Filipe Kiss (<a href="https://codepen.io/filipekiss">@filipekiss</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
      </template>
    </demo-block>
    
    <!--#03 环形 Loading效果-->
    <h3>环形 Loading效果</h3>
    <demo-block>
      <template slot='blackboard'>
        <demo-box thisName='LoadingAnimation0301'>
          <loading-animation0301></loading-animation0301>
        </demo-box>
        <demo-box thisName='LoadingAnimation0302'>
          <loading-animation0302></loading-animation0302>
        </demo-box>
        <demo-box thisName='LoadingAnimation0303'>
          <loading-animation0303></loading-animation0303>
        </demo-box>
        <demo-box thisName='LoadingAnimation0304'>
          <loading-animation0304></loading-animation0304>
        </demo-box>
        <demo-box thisName='LoadingAnimation0305'>
          <loading-animation0305></loading-animation0305>
        </demo-box>
        <demo-box thisName='LoadingAnimation0306'>
          <loading-animation0306></loading-animation0306>
        </demo-box>
      </template>
      
      <template slot='realization'>
        <p data-height="265" data-theme-id="light" data-slug-hash="yJxFo" data-default-tab="css,result" data-user="filipekiss" data-pen-title="Loading Animations" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/filipekiss/pen/yJxFo/">Loading Animations</a> by Filipe Kiss (<a href="https://codepen.io/filipekiss">@filipekiss</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
        <p data-height="265" data-theme-id="light" data-slug-hash="wBQveM" data-default-tab="css,result" data-user="martinvd" data-pen-title="CSS loading animation 9" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/martinvd/pen/wBQveM/">CSS loading animation 9</a> by Martin van Driel (<a href="https://codepen.io/martinvd">@martinvd</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
        <p data-height="265" data-theme-id="light" data-slug-hash="aIuko" data-default-tab="css,result" data-user="francoislesenne" data-pen-title="Loading animation with keyframe for SCSS & Jade."
           data-preview="true" class="codepen">See the Pen <a href="https://codepen.io/francoislesenne/pen/aIuko/">Loading animation with keyframe for SCSS & Jade.</a> by François Lesenne (<a
          href="https://codepen.io/francoislesenne">@francoislesenne</a>) on <a href="https://codepen.io">CodePen</a>.</p>
      </template>
    </demo-block>
    
    <!--#04 丝带 Loading效果-->
    <h3>丝带 Loading效果</h3>
    <demo-block>
      <template slot='blackboard'>
        <demo-box thisName='LoadingAnimation0401'>
          <loading-animation0401></loading-animation0401>
        </demo-box>
      </template>
      
      <template slot='realization'>
        <p data-height="265" data-theme-id="light" data-slug-hash="xbQJom" data-default-tab="css,result" data-user="martinvd" data-pen-title="CSS loading animation 12" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/martinvd/pen/xbQJom/">CSS loading animation 12</a> by Martin van Driel (<a href="https://codepen.io/martinvd">@martinvd</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
      </template>
    </demo-block>
    
    <!--#05 其他 Loading效果-->
    <h3>其他 Loading效果</h3>
    <demo-block>
      <template slot='blackboard'>
        <demo-box thisName='LoadingAnimation0501'>
          <loading-animation0501></loading-animation0501>
        </demo-box>
        <demo-box thisName='LoadingAnimation0502'>
          <loading-animation0502></loading-animation0502>
        </demo-box>
        <demo-box thisName='LoadingAnimation0503'>
          <loading-animation0503></loading-animation0503>
        </demo-box>
        <demo-box thisName='LoadingAnimation0505'>
          <loading-animation0505></loading-animation0505>
        </demo-box>
        <demo-box thisName='LoadingAnimation0506'>
          <loading-animation0506></loading-animation0506>
        </demo-box>
        <demo-box thisName='LoadingAnimation0504'>
          <loading-animation0504></loading-animation0504>
        </demo-box>
        <demo-box thisName='LoadingAnimation0507'>
          <loading-animation0507></loading-animation0507>
        </demo-box>
        <demo-box thisName='LoadingAnimation0508'>
          <loading-animation0508></loading-animation0508>
        </demo-box>
      </template>
      
      <template slot='realization'>
        <p data-height="265" data-theme-id="light" data-slug-hash="yJxFo" data-default-tab="css,result" data-user="filipekiss" data-pen-title="Loading Animations" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/filipekiss/pen/yJxFo/">Loading Animations</a> by Filipe Kiss (<a href="https://codepen.io/filipekiss">@filipekiss</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
        <p data-height="265" data-theme-id="light" data-slug-hash="CxliK" data-default-tab="css,result" data-user="hakimel" data-pen-title="CSS Spinner Animation" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/hakimel/pen/CxliK/">CSS Spinner Animation</a> by Hakim El Hattab (<a href="https://codepen.io/hakimel">@hakimel</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
        <p data-height="265" data-theme-id="light" data-slug-hash="OoMxYG" data-default-tab="css,result" data-user="akshaycodes" data-pen-title="CSS Double Helix #07" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/akshaycodes/pen/OoMxYG/">CSS Double Helix #07</a> by Akshay (<a href="https://codepen.io/akshaycodes">@akshaycodes</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
        <p data-height="265" data-theme-id="light" data-slug-hash="oKxep" data-default-tab="css,result" data-user="TaniaLD" data-pen-title="Loaders (WIP)" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/TaniaLD/pen/oKxep/">Loaders (WIP)</a> by Tania LD (<a href="https://codepen.io/TaniaLD">@TaniaLD</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
        <p data-height="265" data-theme-id="light" data-slug-hash="MYxYeo" data-default-tab="html,result" data-user="madetoday" data-pen-title="Hourglass loader" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/madetoday/pen/MYxYeo/">Hourglass loader</a> by Lenka (<a href="https://codepen.io/madetoday">@madetoday</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
        <p data-height="265" data-theme-id="0" data-slug-hash="KBxYZg" data-default-tab="css,result" data-user="comehope" data-pen-title="Roller coaster loader" data-preview="true"
           class="codepen">See the Pen <a href="https://codepen.io/comehope/pen/KBxYZg/">Roller coaster loader</a> by Comehope (<a href="https://codepen.io/comehope">@comehope</a>) on <a
          href="https://codepen.io">CodePen</a>.</p>
      </template>
    </demo-block>
  </div>
</template>

<script type='text/javascript'>
  import DemoBlock from 'local/DemoBlock'
  import BreathingLight from 'styleParts/BreathingLight'
  import LoadingAnimation0101 from 'styleParts/loadingAnimation/LoadingAnimation0101'
  import LoadingAnimation0102 from 'styleParts/loadingAnimation/LoadingAnimation0102'
  import LoadingAnimation0201 from 'styleParts/loadingAnimation/LoadingAnimation0201'
  import LoadingAnimation0202 from 'styleParts/loadingAnimation/LoadingAnimation0202'
  import LoadingAnimation0203 from 'styleParts/loadingAnimation/LoadingAnimation0203'
  import LoadingAnimation0204 from 'styleParts/loadingAnimation/LoadingAnimation0204'
  import LoadingAnimation0301 from 'styleParts/loadingAnimation/LoadingAnimation0301'
  import LoadingAnimation0302 from 'styleParts/loadingAnimation/LoadingAnimation0302'
  import LoadingAnimation0303 from 'styleParts/loadingAnimation/LoadingAnimation0303'
  import LoadingAnimation0304 from 'styleParts/loadingAnimation/LoadingAnimation0304'
  import LoadingAnimation0305 from 'styleParts/loadingAnimation/LoadingAnimation0305'
  import LoadingAnimation0306 from 'styleParts/loadingAnimation/LoadingAnimation0306'
  import LoadingAnimation0401 from 'styleParts/loadingAnimation/LoadingAnimation0401'
  import LoadingAnimation0501 from 'styleParts/loadingAnimation/LoadingAnimation0501'
  import LoadingAnimation0502 from 'styleParts/loadingAnimation/LoadingAnimation0502'
  import LoadingAnimation0503 from 'styleParts/loadingAnimation/LoadingAnimation0503'
  import LoadingAnimation0504 from 'styleParts/loadingAnimation/LoadingAnimation0504'
  import LoadingAnimation0505 from 'styleParts/loadingAnimation/LoadingAnimation0505'
  import LoadingAnimation0506 from 'styleParts/loadingAnimation/LoadingAnimation0506'
  import LoadingAnimation0507 from 'styleParts/loadingAnimation/LoadingAnimation0507'
  import LoadingAnimation0508 from 'styleParts/loadingAnimation/LoadingAnimation0508'
  import Catalog from 'progress-catalog'
  
  export default {
    name: 'LoadingAnimation',
    components: {
      LoadingAnimation0101, LoadingAnimation0102,
      LoadingAnimation0201, LoadingAnimation0202,
      LoadingAnimation0203, LoadingAnimation0204,
      LoadingAnimation0301, LoadingAnimation0302,
      LoadingAnimation0303, LoadingAnimation0304,
      LoadingAnimation0305, LoadingAnimation0306,
      LoadingAnimation0401,
      LoadingAnimation0501, LoadingAnimation0502,
      LoadingAnimation0503, LoadingAnimation0504,
      LoadingAnimation0505, LoadingAnimation0506,
      LoadingAnimation0507, LoadingAnimation0508, DemoBlock
    },
    mounted() {
      new Catalog({
        contentEl: 'loading-animation',
        catalogEl: `catalog-content-${this.$options.name}`,
        selector: ['h2', 'h3']
      })
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "~styles/mixin.scss";
  
  .loading {
    a {
      color: $green;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/LoadingAnimation.vue